import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AlertBanner } from '@spark';

/**
 * Dismissible info banner at the top of a step (records summary or empty
 * dataset copy). Wraps Spark `AlertBanner` with local dismissed state.
 */
const InfoBanner = ({ text }) => {
    const [dismissed, setDismissed] = useState(false);
    if (dismissed || !text) return null;
    return (
        <AlertBanner
            className="gdai-banner"
            feedback="info"
            text={<span className="fs-unmask">{text}</span>}
            showButton={false}
            onCloseClick={() => setDismissed(true)}
        />
    );
};

InfoBanner.propTypes = {
    text: PropTypes.node,
};

export default InfoBanner;
